import { z } from 'zod';

export const newSemenTransactionFormSchema = z.object({
  date: z.date({ required_error: 'Date is required' }),
  transactionId: z.string().min(1, 'Transaction ID is required'),
  quantity: z
    .number({ required_error: 'Quantity is required' })
    .int()
    .optional(),
  description: z.string().min(1, 'Description is required'),
  newOwner: z
    .object({
      id: z.string().uuid(),
      name: z.string(),
    })
    .optional(),
  newLocation: z
    .object({
      id: z.string().uuid(),
      name: z.string(),
    })
    .optional(),
  semenId: z.string().uuid().optional(),
  previousOwner: z
    .object({
      id: z.string().uuid(),
      name: z.string(),
    })
    .optional(),
  quantityBeforeTransaction: z.number().int().optional(),
  previousLocation: z
    .object({
      id: z.string().uuid(),
      name: z.string(),
    })
    .optional(),
});

export type NewSemenTransactionFormValues = z.infer<
  typeof newSemenTransactionFormSchema
>;
